import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: [],
  status: 'idle',
}

export const permissionSlice = createSlice({
  name: 'permissions',
  initialState,

  reducers: {
    setPermission: (state, action) => {
        state.value = Array.isArray(action.payload) ? action.payload : [];
    },
  },
});

export const { setPermission } = permissionSlice.actions;

export const permissions = (state) => state.permissions.value;

export default permissionSlice.reducer;